import { render, staticRenderFns } from "./regional_analysis.vue?vue&type=template&id=5224977e&scoped=true"
import script from "./regional_analysis.vue?vue&type=script&lang=js"
export * from "./regional_analysis.vue?vue&type=script&lang=js"
import style0 from "./regional_analysis.vue?vue&type=style&index=0&id=5224977e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224977e",
  null
  
)

export default component.exports